<template>
	<section v-if="loading" class="trackme-loading trackme-loading-show d-flex justify-content-center align-items-center">
		<div class="trackme-loading-center">
			<img :src="require('./../../assets/images/gstrackme-loading-white.gif')" alt="">
		</div>
	</section>
</template>

<script>
import { EventBus } from './../../main';

export default {
	methods: {
		// afterEnter() {
		// 	this.loading = false;
		// }
	},
	data() {
		return {
			loading: false
		}
	},
	mounted() {
		EventBus.$on('loadingShow', () => {
			this.loading = true;
		})

		EventBus.$on('loadingClose', () => {
			this.loading = false;
		})
	}
}
</script>

<style scoped>
.trackme-loading {
	background-color: rgba(0, 0, 0, 0.7);
	bottom: 0;
	left: 0;
	opacity: 0;
	position: fixed;
	right: 0;
	top: 0;
	transition: all 0.3s;
	-moz-transition: all 0.3s;
	-webkit-transition: all 0.3s;
	z-index: -1;
}

.trackme-loading.trackme-loading-show {
	opacity: 1;
	z-index: 10000;
}

.trackme-loading img {
	width: 320px;
}
</style>
